import React, { useState } from 'react';
import { 
  FiFileText, 
  FiDownload, 
  FiCalendar, 
  FiCheckCircle,
  FiPrinter,
  FiGrid,
  FiDollarSign
} from 'react-icons/fi';

const Reports = () => {
  const colors = {
    primary: '#085e53',
    secondary: '#267c77',
    bg: '#f8fafc'
  };

  const reportTypes = [
    { id: 1, title: 'मासिक कामकाज अहवाल', desc: 'ग्रामपंचायतींच्या मासिक कामकाजाचा सविस्तर आढावा.', icon: <FiFileText /> },
    { id: 2, title: 'महसूल संकलन अहवाल', desc: 'कर आणि तो कर वसुलीची आर्थिक आकडेवारी.', icon: <FiDollarSign /> },
    { id: 3, title: 'अर्ज स्थिती अहवाल', desc: 'आलेल्या अर्जांचे वर्गीकरण आणि स्थिती अहवाल.', icon: <FiCheckCircle /> },
    { id: 4, title: 'योजना लाभार्थी अहवाल', desc: 'विविध योजनांचा लाभ घेतलेल्या लाभार्थ्यांची यादी.', icon: <FiGrid /> },
    { id: 5, title: 'ऑडिट अहवाल', desc: 'सिस्टम मधील क्रियांचे ऑडिट लॉग.', icon: <FiFileText /> },
    { id: 6, title: 'कर्मचारी उपस्थिती', desc: 'ग्रामपंचायत कर्मचाऱ्यांची उपस्थिती नोंद.', icon: <FiCalendar /> },
  ];

  return (
    <div className="p-6 min-h-screen" style={{ backgroundColor: colors.bg }}>
      <div className="mb-8">
        <h1 className="text-2xl font-bold mb-1" style={{ color: colors.primary }}>अहवाल विभाग</h1>
        <p className="text-gray-600 text-sm">विविध प्रकारचे अहवाल तयार करा आणि डाउनलोड करा.</p>
      </div>

      {/* Filter Section */}
      <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 mb-8">
        <h3 className="font-bold text-gray-800 mb-4 border-b pb-2">अहवाल सेटिंग्ज</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">ग्रामपंचायत निवडा</label>
            <select className="w-full p-2.5 border rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-teal-500">
              <option>सर्व ग्रामपंचायती</option>
              <option>इनाम धामणी</option>
              <option>बेडग</option>
              <option>आरग</option>
            </select>
          </div>
          <div>
             <label className="block text-sm font-medium text-gray-700 mb-1">दिनांक श्रेणी (पासून)</label>
             <input type="date" className="w-full p-2.5 border rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-teal-500" />
          </div>
          <div>
             <label className="block text-sm font-medium text-gray-700 mb-1">दिनांक श्रेणी (पर्यंत)</label>
             <input type="date" className="w-full p-2.5 border rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-teal-500" />
          </div>
        </div>
      </div>

      {/* Report Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {reportTypes.map((report) => (
          <div key={report.id} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all group">
            <div className="flex items-start justify-between mb-4">
               <div className="p-3 bg-teal-50 text-teal-700 rounded-lg group-hover:bg-teal-100 transition-colors">
                 {React.cloneElement(report.icon, { size: 24 })}
               </div>
               <span className="text-xs font-semibold px-2 py-1 bg-gray-100 text-gray-600 rounded">PDF / Excel</span>
            </div>
            <h3 className="text-lg font-bold text-gray-800 mb-2">{report.title}</h3>
            <p className="text-gray-500 text-sm mb-6 h-10">{report.desc}</p>
            
            <div className="flex gap-2">
              <button 
                className="flex-1 flex items-center justify-center py-2 px-4 border border-teal-600 text-teal-700 rounded-lg text-sm font-medium hover:bg-teal-50 transition-colors"
              >
                <FiDownload className="mr-2" /> PDF
              </button>
              <button 
                className="flex-1 flex items-center justify-center py-2 px-4 bg-teal-600 text-white rounded-lg text-sm font-medium hover:bg-teal-700 transition-colors"
                style={{ backgroundColor: colors.primary }}
              >
                <FiPrinter className="mr-2" /> Excel
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Reports;
